<template>
  <div>
    <v-container fluid>
      <v-row>
        <v-col cols="11" class="mx-auto my-6" align="center">
          <h2>Votre séance de sport à sauvegarder</h2>
          <v-divider></v-divider>
        </v-col>
      </v-row>
      <v-form ref="form" v-model="valid" lazy-validation>
        <v-row>
          <v-spacer></v-spacer>
          <v-col cols="12" md="4" class="col-sm-6 mr-12">
            <v-date-picker
              v-model="picker"
              locale="fr"
              color="#2837bf"
              elevation="6"
              @input="updateNote"
              :events="arrayEvents"
              event-color="green lighten-1"
            ></v-date-picker>
            <v-text-field
              v-show="false"
              readonly
              v-model="picker"
              :rules="pickerRules"
              solo
              class="mt-2"
            ></v-text-field>
          </v-col>

          <v-col cols="12" sm="5" class>
            <v-textarea
              v-model="personalNote"
              @keydown="preventWritingOnMaxCharacter"
              background-color="#f5f5f5"
              label="Notes personnelles"
              placeholder="Vous pouvez ici même rentrez vos notes personnelles vis à vis de votre séance."
              clearable
              counter="420"
              height="270px"
              outlined
              :rules="personalNoteRules"
              no-resize
            ></v-textarea>
            <v-btn
              block
              large
              class="py-6 my-6 white--text"
              :disabled="
                !personalNote || !picker || !$store.getters.isUserLoggedIn
              "
              elevation="6"
              color="#2837bf"
              @click="saveSession"
              >Sauvegarder</v-btn
            >
          </v-col>
          <v-spacer></v-spacer>
        </v-row>
      </v-form>
    </v-container>
  </div>
</template>

<script>
export default {
  data() {
    return {
      arrayEvents: this.$store.getters.getAllSessionsDates,
      valid: false,
      personalNote: "",
      personalNoteRules: [
        v =>
          (v && v.length <= 420) ||
          "Vous devez remplir votre note personnelle (440 caractères max)."
      ],
      picker: null,
      pickerRules: [v => !!v || "Veuillez sélectionner une date."]
    };
  },
  methods: {
    preventWritingOnMaxCharacter(event) {
      const backspace = "Backspace";
      if (this.personalNote.length >= 420 && event.key != backspace) {
        event.preventDefault();
      }
    },
    saveSession() {
      //fetch data
      const date = this.picker;
      const note = this.personalNote;
      const userId = this.$store.state.user.userId;

      this.$store.dispatch("saveSession", {
        date: date,
        note: note,
        userId: userId
      });
    },
    updateNote(date) {
      const session = this.$store.state.userSessions.sessions[date];

      if (!session) {
        this.personalNote = "";
        this.$refs.form.resetValidation();
        return;
      }

      this.personalNote = session.note;
    }
  },
  computed: {}
};
</script>

<style lang="scss" scoped>
</style>